import { Text } from '@components/ui';
import {
  checkboxChecked,
  displayAddress,
  displayScalar,
} from '@features/buyer/jobs/criteria-option/criteriaDisplay';
import type {
  GroupedOptions,
  ScalarFieldEntry,
  SelectedEntry,
} from '@features/buyer/jobs/criteria-option/criteriaOptionTypes';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import type { ReactNode } from 'react';

interface CriteriaFieldValuesProps {
  selectedDropdownsArr: SelectedEntry[];
  typeDropdown: GroupedOptions[];
  typeText: ScalarFieldEntry[];
  typeNumber: ScalarFieldEntry[];
  typeDate: ScalarFieldEntry[];
  typeTime: ScalarFieldEntry[];
  typeLocation: ScalarFieldEntry[];
  typeCheckbox: ScalarFieldEntry[];
}

const ValueCard = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): JSX.Element => (
  <Box
    sx={{
      borderRadius: 1.5,
      border: 1,
      borderColor: 'divider',
      bgcolor: 'background.paper',
      px: 1.5,
      py: 1.25,
    }}
  >
    <Text
      as="span"
      sx={{
        display: 'block',
        mb: 0.5,
        fontSize: 12,
        fontWeight: 600,
        color: 'text.secondary',
      }}
    >
      {title}
    </Text>
    <Text sx={{ fontSize: 14, overflowWrap: 'anywhere' }}>{children}</Text>
  </Box>
);

export function CriteriaFieldValues({
  selectedDropdownsArr,
  typeDropdown,
  typeText,
  typeNumber,
  typeDate,
  typeTime,
  typeLocation,
  typeCheckbox,
}: CriteriaFieldValuesProps): JSX.Element {
  return (
    <>
      <Grid container spacing={1.5} sx={{ mt: 0 }}>
        {selectedDropdownsArr?.length > 0 && typeDropdown?.length > 0
          ? typeDropdown?.map((item, index) => (
              <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                <ValueCard title={item.heading ?? ''}>
                  {item.options?.map((option) => {
                    if (option.ratingCriteriaUser !== null) {
                      return <span key={option.id}>{option.ratingValue}</span>;
                    }
                    return null;
                  })}
                </ValueCard>
              </Grid>
            ))
          : null}
        {typeText.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            <ValueCard title={item.ratingTitle ?? ''}>
              {displayScalar(item?.value?.value)}
            </ValueCard>
          </Grid>
        ))}
        {typeNumber.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            <ValueCard title={item.ratingTitle ?? ''}>
              {displayScalar(item?.value?.value)}
            </ValueCard>
          </Grid>
        ))}
        {typeDate.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            <ValueCard title={item.ratingTitle ?? ''}>
              {displayScalar(item?.value?.value)}
            </ValueCard>
          </Grid>
        ))}
        {typeTime.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            <ValueCard title={item.ratingTitle ?? ''}>
              {displayScalar(item?.value?.value)}
            </ValueCard>
          </Grid>
        ))}
        {typeLocation.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            <ValueCard title={item.ratingTitle ?? ''}>
              {displayAddress(item?.value?.value)}
            </ValueCard>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 1.25 }}>
        {typeCheckbox.map((item, index) => (
          <FormGroup key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={checkboxChecked(item?.value?.value)}
                  disabled
                />
              }
              label={item.ratingTitle}
            />
          </FormGroup>
        ))}
      </Box>
    </>
  );
}
